import React  from "react";

import './Day.scss';

const Day = ({ day, isActive, onSelectedDay}) => {
    return (
        <div className= {isActive ? "day active" : "day"} onClick={ () => onSelectedDay(day)}>
            <div className="weekday">{day.weekday}</div>
            <div className="data">{day.label}</div>
        </div>
    );
  };
  
  export default Day;